import { useContext } from "react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { API_URL_PROJECTS } from "constants/api_urls";
import { AxiosContext } from "contexts/AxiosContext";
import { IProjectsResponse } from "interfaces/project";
import { makeQueryString } from "core/makeQueryString";

export const useProjectsQuery = (): UseQueryResult<
  IProjectsResponse,
  unknown
> => {
  const { axios } = useContext(AxiosContext)!;

  return useQuery({
    queryKey: ["projects", "page1"],
    queryFn: async () => {
      const { data } = await axios.get<IProjectsResponse>(
        `${API_URL_PROJECTS}${makeQueryString({
          page: 1,
          size: 1,
          ordering: "name"
        })}`
      );

      return data;
    },
    cacheTime: 0,
    refetchOnWindowFocus: false
  });
};
